// Enums globales de la aplicación

export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
  GUEST = 'guest'
}

export enum UserGroup {
  ADMIN_GROUP = 'Admin-Group',
  USER_GROUP = 'User-Group',
  GUEST_GROUP = 'Guest-Group'
}

export enum Status {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending'
}

export enum CampaignStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export enum ReportType {
  GENERAL = 'general',
  DETAILED = 'detailed',
  SUMMARY = 'summary'
}
